import { CDNRoutes, getFullRouteUrl, Routes } from "@/api";
import { Metadata } from "next";

const metadata = {
  title: "Crypto Portfolio Tracker 2025 | Denomos",
  description:
    "Track your crypto portfolio with Denomos's analytics. Connect wallets or CEXes, and monitor real-time metrics. Start now!",
  keywords:
    "crypto portfolio analytics, crypto tracking, risk metrics, correlation analysis, portfolio monitoring",
  robots: "index, follow",
  openGraph: {
    type: "website",
    locale: "en_US",
    url: process.env.NEXT_PUBLIC_BASE_URL,
    siteName: "Denomos",
    title: "Crypto Portfolio Tracker 2025 | Denomos",
    description:
      "Track your crypto portfolio with Denomos's analytics. Connect wallets or CEXes, and monitor real-time metrics. Start now!",
    images: [
      {
        url: CDNRoutes.openGraph("denomos-og-image-1.webp"),
        width: 1200,
        height: 630,
        alt: "Denomos Crypto Portfolio Analytics Platform",
      },
    ],
  },
  twitter: {
    card: "summary_large_image",
    title: "Crypto Portfolio Tracker 2025 | Denomos",
    description:
      "Track your crypto portfolio with Denomos's analytics. Connect wallets or CEXes, and monitor real-time metrics. Start now!",
    images: [
      {
        url: CDNRoutes.openGraph("denomos-og-image-1.webp"),
        width: 1200,
        height: 630,
        alt: "Denomos Crypto Portfolio Analytics Platform",
      },
    ],
  },
  other: {
    "version-tag": process.env.NEXT_PUBLIC_APP_VERSION,
  },
} satisfies Metadata;

const referral = {
  title: "Denomos: Crypto Portfolio Analytics 2025",

  link: (userId: string, code: string) => {
    return getFullRouteUrl(Routes.AFFILIATE_LINK(userId, code));
  },
} as const;

export const seo = {
  metadata,
  socials: {
    x: "https://x.com/denomosplatform",
    instagram: "https://www.instagram.com/denomosplatform",
    tiktok: "https://www.tiktok.com/@denomos.com",
    discord: "https://discord.gg/9rK4M9fx5v",
  },
  referral,
} as const;
